module.exports = __webpack_public_path__ + "static/img/head.0e907e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/multiomics/head.png
// module id = Qq3r
// module chunks = 1